import {
  BarChart,
  Code,
  ContentCopy,
  Edit,
  IosShare,
  MoreVert,
  Preview,
  Publish
} from '@mui/icons-material'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ListSubheader,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import DownloadButton from '../../Document/DownloadButton'
import EmailShare from '../../Email/EmailShare'
import { useState } from 'react'
import { PaperComponent } from '../../Helpers/Drag'
import { useNavigate } from 'react-router-dom'

const PulseAdminMenu = ({ isDraftCheck, db, document }) => {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState(null)

  const [showEmbedDialog, setShowEmbedDialog] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const openMenu = Boolean(anchorEl)
  const handleOpenMenu = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleOpenMenuClose = () => {
    setAnchorEl(null)
  }
  const getRoute = () => {
    return document.customRoute.length > 0 ? document.customRoute : document.id
  }

  return (
    <>
      <Tooltip title='Admin Actions'>
        <IconButton
          size='small'
          id='basic-button'
          aria-controls={openMenu ? 'basic-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={openMenu ? 'true' : undefined}
          onClick={handleOpenMenu}
          color='primary'
        >
          <MoreVert />
        </IconButton>
      </Tooltip>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleOpenMenuClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button'
          }
        }}
      >
        {isDraftCheck(document) ? (
          <MenuItem
            onClick={e => {
              handleOpenMenuClose(e)
              navigate('/draftPulse/' + document.id)
            }}
          >
            <Publish sx={{ mr: 1 }} />
            Finish Upload
          </MenuItem>
        ) : (
          <MenuItem
            onClick={e => {
              handleOpenMenuClose(e)
              navigate('/editPulse/' + document.id)
            }}
          >
            <Edit sx={{ mr: 1 }} />
            Edit
          </MenuItem>
        )}

        {!isDraftCheck(document) && (
          <>
            <MenuItem
              onClick={e => {
                handleOpenMenuClose(e)
                navigate('/viewPulsePreview/' + getRoute())
              }}
            >
              <Preview sx={{ mr: 1 }} />
              Preview Mode
            </MenuItem>
            <ListSubheader>Reporting:</ListSubheader>
            <MenuItem
              onClick={e => {
                handleOpenMenuClose(e)
                navigate('/viewPulseReport/' + getRoute())
              }}
            >
              <BarChart sx={{ mr: 1 }} />
              View Report
            </MenuItem>

            <DownloadButton
              document={document}
              db={db}
              isPulse={true}
              isMenuItem={true}
            />

            <ListSubheader>Sharing:</ListSubheader>
            <MenuItem
              onClick={e => {
                handleOpenMenuClose(e)
                setShowModal(true)
              }}
            >
              <IosShare sx={{ mr: 1 }} />
              Share
            </MenuItem>

            <MenuItem
              onClick={e => {
                handleOpenMenuClose(e)
                setShowEmbedDialog(true)
              }}
            >
              <Code sx={{ mr: 1 }} />
              Embed
            </MenuItem>
          </>
        )}
      </Menu>
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'
        fullWidth
      >
        <EmailShare
          setShowModal={setShowModal}
          db={db}
          id={document.id}
          viewCode={document.viewCode || null}
          fileName={document.fileName}
          customURL={document.customRoute || null}
          isPulse={true}
        />
      </Dialog>
      <Dialog
        open={showEmbedDialog}
        onClose={() => setShowEmbedDialog(false)}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'
        fullWidth
      >
        <Embed
          setShow={setShowEmbedDialog}
          title={document.fileName}
          getRoute={getRoute}
        />
      </Dialog>
    </>
  )
}

const Embed = ({ setShow, title, getRoute }) => {
  const [showAlert, setShowAlert] = useState(false)

  function copy () {
    navigator.clipboard.writeText(
      '<iframe src="' +
        window.location.origin +
        '/viewPulse/' +
        (getRoute()) +
        '" style="width: 100%; height: 100%;"></iframe>'
    )
    setShowAlert(true)
  }
  return (
    <>
      <DialogTitle>Embed {title}</DialogTitle>
      <DialogContent>
        <Typography variant='span' component='div' sx={{ mb: 2 }}>
          Add code to your website and allow users to interact with your Pulse
          right on your website!
          <br />
          <br />
          Admin actions will be restricted, and Community Document features like
          search, profile, upload and dashboard will be disabled.
        </Typography>
        {showAlert && (
          <Alert
            variant='filled'
            severity='success'
            onClose={() => {
              setShowAlert(false)
            }}
            sx={{ mb: 1 }}
          >
            Copied to Clipboard!
          </Alert>
        )}
        <TextField
          label='Embedding Code'
          multiline
          fullWidth
          rows={4}
          sx={{ mt: 2 }}
          variant='outlined'
          value={
            '<iframe src="' +
            window.location.origin +
            '/viewPulse/' +
            getRoute() +
            '" style="width: 100%; height: 100%;"></iframe>'
          }
          disabled={true}
        />
      </DialogContent>
      <DialogActions>
        <Button
          startIcon={<ContentCopy />}
          onClick={copy}
          variant='contained'
          color='success'
        >
          Copy
        </Button>
        <Button onClick={() => setShow(false)}>Close</Button>
      </DialogActions>
    </>
  )
}

export default PulseAdminMenu
